import { render, staticRenderFns } from "./BulkSmsPostacell.vue?vue&type=template&id=99258ebc&scoped=true"
import script from "./BulkSmsPostacell.vue?vue&type=script&lang=js"
export * from "./BulkSmsPostacell.vue?vue&type=script&lang=js"
import style0 from "./BulkSmsPostacell.vue?vue&type=style&index=0&id=99258ebc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99258ebc",
  null
  
)

export default component.exports